const indexItems = [
  { letter: 'A', title: '动作电影大全', desc: '枪战·格斗·追车·热血', count: '5200+' },
  { letter: 'B', title: '爆笑喜剧合集', desc: '轻松·欢乐·治愈·搞笑', count: '3800+' },
  { letter: 'C', title: '超级英雄系列', desc: '漫威·DC·超能·热血', count: '1200+' },
  { letter: 'D', title: '都市情感剧场', desc: '爱情·都市·青春·温暖', count: '4600+' },
  { letter: 'E', title: '儿童动画专区', desc: '益智·童话·冒险·成长', count: '3200+' },
  { letter: 'F', title: '犯罪悬疑烧脑', desc: '推理·反转·高能·紧张', count: '2800+' },
  { letter: 'G', title: '国产经典怀旧', desc: '老片·回忆·经典·情怀', count: '6500+' },
  { letter: 'H', title: '海外大片精选', desc: '好莱坞·韩影·日影·泰影', count: '4100+' },
  { letter: 'I', title: 'IMDb高分神作', desc: '评分·口碑·经典·必看', count: '1800+' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              全站导航
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              主题索引
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              按主题快速找到你想看的内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item) => (
              <div
                key={item.letter}
                className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                  <span className="font-heading text-lg font-bold text-accent-700">{item.letter}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{item.desc}</p>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}